import React from 'react'

const DesktopOnboarding = () => {
  return (
    <div className='h-[100vh] w-[100vw] relative bg-gradient-to-b from-[#253246] to-[#1e2738] flex justify-center items-center'>
      
      <img
        src={`${process.env.PUBLIC_URL}/desktopOpening.png`}
        alt='onboarding background'
        className='relative z-10 w-[65vw]'
      />

    </div>
  )
}

export default DesktopOnboarding